var styles = {"viewMode":"x0rQE","editMode":"mSGCN","container":"okQLv","cell":"yloL2"};

export { styles as s };

import 'wix-rich-content-plugin-table/dist/loadable/viewer/es/styles.viewer.min.global.css'